import React, { Fragment, useContext, useState } from "react";
import propTypes from "prop-types";
import { Report, ReportType } from "../../../../logic/api";
import styles from "./styles";

import {
    FiBarChart,
    FiChevronRight,
    FiClock,
    FiCodesandbox,
    FiEdit,
    FiInfo,
    FiTrash,
} from 'react-icons/fi';

import flex from "../../../../styles/flex";
import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";
import { IconButton, Tooltip } from "@mui/material";
import { isSysAdmin } from "../../../../utility/utils";
import { SessionContext } from "../../../../utility/useSession";
import { useTranslation } from "react-i18next";

const ReportListItem: React.FunctionComponent<{
    item: Report,
    onClick: () => void,
    onDelete: () => void,
    onEdit: () => void,
    onDesign: () => void,
}> = (props) => {

    const border = props.item.reportType == ReportType.standard ? styles.border : styles.borderBlue;
    const [deleted, setDeleted] = useState(false);
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    if (deleted == true) {
        return <Fragment></Fragment>
    }
    return (
        <div style={{ ...styles.listItem, ...border }} >
            <div style={styles.listItemFlex}>

                <ListViewItemCard
                    icon={<FiBarChart style={styles.icon} />}
                    text={props.item.name}
                    subText={props.item.category.categoryName}
                    onClick={() => {
                        if (props.onClick != null) {
                            props.onClick();
                        }
                    }}
                />

                {(`${props.item.description ?? ""}`.length > 0) && (
                    <Tooltip title={<span style={{ fontSize: 20, padding: 8, lineHeight: 1.2 }}>{props.item.description}</span>}>
                        <IconButton>
                            <FiInfo />
                        </IconButton>
                    </Tooltip>
                )}
                {(isSysAdmin(session) && props.item.reportType == ReportType.centralised) && (
                    <div style={flex.flexAuto} onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        props.onDesign()
                        return false;
                    }}>
                        <IconButton>
                            <FiClock />
                        </IconButton>
                    </div>
                )}
                {(isSysAdmin(session) && props.item.reportType == ReportType.standard) && (
                    <Fragment>
                        <div style={flex.flexAuto} onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            props.onEdit()
                            return false;
                        }}>
                            <IconButton>
                                <FiEdit />
                            </IconButton>
                        </div>
                        <div style={flex.flexAuto} onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            props.onDesign();
                            return false;
                        }}>
                            <IconButton>
                                <FiCodesandbox />
                            </IconButton>
                        </div>
                        <div style={flex.flexAuto} onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (confirm(t("lists.confirmDeleteReport"))) {
                                setDeleted(true);
                                props.onDelete();
                            }
                            return false;
                        }}>
                            <IconButton>
                                <FiTrash />
                            </IconButton>
                        </div>
                    </Fragment>
                )}

                <div style={flex.flexAuto}>
                    <div style={{ ...flex.flexRows, alignItems: "center", height: "100%" }}>
                        <div style={flex.flexAuto}>
                            <FiChevronRight style={styles.iconChevron} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


ReportListItem.propTypes = {
    item: propTypes.any.isRequired,
    onClick: propTypes.func.isRequired,
    onDelete: propTypes.func.isRequired,
    onEdit: propTypes.func.isRequired,
    onDesign: propTypes.func.isRequired,
};


export default ReportListItem;